import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { User, ConfirmationResult } from 'firebase/auth';

interface AuthState {
  user: User | null;
  loading: boolean;
  error: string | null;
  emailForSignIn: string | null;
  phoneConfirmationResult: ConfirmationResult | null;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setEmailForSignIn: (email: string | null) => void;
  setPhoneConfirmationResult: (result: ConfirmationResult | null) => void;
  clearPhoneConfirmation: () => void;
}

export const useAuthStore = create<AuthState>()(
  devtools(
    (set) => ({
      user: null,
      loading: true,
      error: null,
      emailForSignIn: null,
      phoneConfirmationResult: null,
      setUser: (user) => set({ user, loading: false }),
      setLoading: (loading) => set({ loading }),
      setError: (error) => set({ error, loading: false }),
      setEmailForSignIn: (emailForSignIn) => set({ emailForSignIn }),
      setPhoneConfirmationResult: (phoneConfirmationResult) => set({ phoneConfirmationResult }),
      clearPhoneConfirmation: () => set({ phoneConfirmationResult: null }),
    }),
    { name: 'AuthStore' },
  ),
);
